import { Container, CssBaseline } from '@mui/material';
import { signOut } from '../utils/auth';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { ErrorBoundary } from './ErrorBoundary';
import Footer from './Footer';
import ResponsiveNavBar from './ResponsiveNavBar';

function Layout() {
  const navigate = useNavigate();
  const location = useLocation();

  async function handleSignOut() {
    const watchVideosMessageClosed = localStorage.getItem(
      'watchVideosMessageClosed',
    );
    const onboardingCompleted = localStorage.getItem('onboardingCompleted');
    localStorage.clear();
    if (watchVideosMessageClosed === 'true') {
      localStorage.setItem('watchVideosMessageClosed', 'true');
    }
    if (onboardingCompleted === 'true') {
      localStorage.setItem('onboardingCompleted', 'true');
    }
    // A session that came from the hosted UI leaves for Cognito's /logout, and
    // routing on top of a navigation already issued would re-render the app on
    // a page it is about to leave.
    const redirected = await signOut({ redirect: true });
    if (!redirected) navigate('/');
  }

  return (
    <div className="d-flex flex-column min-vh-100">
      <ResponsiveNavBar
        handleSignOut={(e) => {
          e.preventDefault();
          handleSignOut();
        }}
      />
      <CssBaseline />
      <main id="main-content" className="flex-grow-1 d-flex" role="main">
        <Container
          maxWidth={false}
          sx={{
            maxWidth: '1320px',
            paddingLeft: '42.528px',
            paddingRight: '42.528px',
          }}
        >
          <ErrorBoundary resetKeys={[location.pathname]}>
            <Outlet />
          </ErrorBoundary>
        </Container>
      </main>
      <Footer />
    </div>
  );
}

export default Layout;
